// extracted by mini-css-extract-plugin
module.exports = {"boxContain":"styles_boxContain__1IZeF","colorContainer":"styles_colorContainer__1EXE7"};